// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Breadcrumbs({ icon, title, route, light }) {
  // Extract only the first route level
  const firstRoute = Array.isArray(route) && route.length > 0 ? route[0] : null;

  return (
    <MDBox ml={{ xs: 0, xl: 1 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) =>
              light ? white.main : grey[600],
          },
        }}
      >
        {firstRoute && (
          <Link to={`/${firstRoute}`} key={firstRoute}>
            <MDTypography
              component="span"
              variant="h5" // Match h5 typography
              fontWeight="medium" // Set font weight to medium
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 1}
              sx={{
                lineHeight: 1.5, // Match h5 line height
                fontSize: "1.25rem", // Explicitly set h5 font size
              }}
            >
              {firstRoute}
            </MDTypography>
          </Link>
        )}
      </MuiBreadcrumbs>
    </MDBox>
  );
}
// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;